<template>
  <div class="block-f">
    <div class="block-f__top">
      <div class="block-f__text" data-aos="fade-up">Зародившись в десятые годы в США, фокстрот приобрёл чрезвычайную популярность в первые же годы существования СССР. Фокстрот танцевали везде: в кафе и домашних салонах; его даже включали в свои спектакли Всеволод Мейерхольд и Николай Фореггер. С закатом «кафейной культуры» фокстрот постепенно был подвергнут гонениям за мещанство и сексуальность и попал под запрет. </div>
      <div class="block-f__title" data-aos="fade-up">Фокстрот</div>
    </div>
    <div class="block-f__content" data-aos="fade-up">
      <div class="block-f__letter letter letter--yellow">Ф.</div>
      <div class="block-f__line">
        <div class="block-f__line-image-1"><img src="../assets/img/f-1.png" alt=""></div>
        <div class="block-f__line-image-2"><img src="../assets/img/f-2.gif" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockF'
}
</script>

<style lang="sass">
  .block-f
    color: #000
    position: relative
    &:after
      content: ''
      width: vw(1px)
      height: vw(1890px)
      background-color: #000
      position: absolute
      top: 0
      margin: auto
      right: 0
      left: 0
      z-index: 100
    &__content
      position: relative
      z-index: 400
    &__top
      display: flex
      position: relative
      z-index: 200
    &__text
      width: vw(480px)
      margin-left: vw(195px)
      text-align: right
      font-family: 'Tautz'
      font-size: vw(16px)
      margin-top: vw(55px)
      letter-spacing: vw(-0.05px)
      line-height: vw(20px)
    &__title
      font-size: vw(72px)
      font-family: 'ZnikomitNo25'
      text-align: right
      margin-left: vw(72px)
      margin-top: vw(124px)
    &__letter
      margin-top: vw(80px)
      margin-left: vw(330px)
      padding-top: vw(17px)
      position: relative
      z-index: 400
      padding-left: vw(27px)
    &__line
      width: vw(1063px)
      height: vw(299px)
      background-image: url(../assets/img/film2.jpg)
      background-size: contain
      margin-left: vw(481px)
      margin-top: vw(-262px)
      display: flex
      position: relative
      z-index: 300
      &-image-2
        width: vw(506px)
        margin-top: vw(30px)
        margin-left: vw(13px)
        height: vw(241px)
        img
          width: 100%
      &-image-1
        width: vw(320px)
        margin-top: vw(30px)
        margin-left: vw(99px)
        height: vw(241px)
        img
          width: 100%

</style>
